<template>
    <div class="md:w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
        <form
            ref="form"
            :action="actionUrl"
            method="POST"
            @submit.prevent="onSubmit()"
        >
            <div
                class="mt-4 bg-white px-2 py-5 px-4 sm:rounded-lg sm:shadow-md sm:border sm:border-gray-200 sm:p-6"
            >
                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <div class="mt-0 md:col-span-2">
                        <input
                            v-if="type === 'edit'"
                            type="hidden"
                            name="_method"
                            value="PATCH"
                        />
                        <input type="hidden" name="_token" :value="csrf" />

                        <PaymentMethodFormFields
                            @cardDataTokenized="onCardDataTokenized"
                            @cardDataTokenizationFailed="
                                onCardDataTokenizationFailed
                            "
                            :addresses="addresses"
                            :countries="countries"
                            :default="$props.default"
                            :defaultAddressId="defaultAddressId"
                            :emailOptIn="emailOptIn"
                            :errors="errors"
                            :includeVerifyField="!!canCreateUnverifiedAddress"
                            :initialCountry="initialCountry"
                            :initialStates="initialStates"
                            :old="old"
                            :paymentGateway="paymentGateway"
                            :paymentMethod="paymentMethod"
                            :type="type"
                        />
                    </div>
                </div>
            </div>

            <div class="sm:px-6 py-6 flex justify-center items-center">
                <div class="w-2/5 sm:w-1/3 pr-1 sm:pr-4">
                    <a
                        role="button"
                        href="/user/payment-methods"
                        class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none w-full"
                    >
                        <XIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                        Cancel
                    </a>
                </div>

                <div class="w-3/5 sm:w-2/3 pl-1 sm:pl-4">
                    <button
                        name="save"
                        type="submit"
                        class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-nutreance-green hover:bg-nutreance-green-darker focus:outline-none w-full"
                    >
                        <LoadingIcon v-if="submitted" class="h-5 w-5 mr-2" />
                        <CheckIcon
                            v-else
                            class="h-5 w-5 mr-2"
                            aria-hidden="true"
                        />
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { inject, ref } from "vue";
import { CheckIcon, XIcon } from "@heroicons/vue/solid";
import type { AppEmitter } from "../../emitter";
import { useForm } from "../../functions/useForm";
import PaymentMethodFormFields from "../paymentMethods/PaymentMethodFormFields.vue";
import LoadingIcon from "../LoadingIcon.vue";

const props = withDefaults(
    defineProps<{
        addresses?: any;
        canCreateUnverifiedAddress?: string;
        countries?: any;
        csrf?: string;
        default?: string;
        defaultAddressId?: string;
        emailOptIn?: string;
        errors?: any;
        initialCountry?: any;
        initialStates?: any;
        old?: any;
        paymentGateway?: any;
        paymentMethod?: any;
        type?: string;
    }>(),
    {
        emailOptIn: "1",
    },
);

const emitter = inject<AppEmitter>("mitt")!;
const { submitted } = useForm();
const form = ref<any>(null);
const actionUrl =
    "/user/payment-methods" +
    (props.type === "edit" ? "/" + props.paymentMethod.id : "");

function onSubmit() {
    if (submitted.value) {
        return;
    }

    submitted.value = true;

    if (props.type === "create") {
        emitter.emit("tokenizeCardData");
        return;
    }

    form.value.submit();
}

function onCardDataTokenized() {
    form.value.submit();
}

function onCardDataTokenizationFailed() {
    submitted.value = false;
}
</script>
